module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/corning/"},"frontmatter":{"title":"Corning"}}}]}},"pathContext":{"tag":"Corning"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-corning.json
// module id = 434
// module chunks = 279802917561594